import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import {
  SearchIcon,
  CalendarIcon,
  BackIcon,
  NavigationIcon,
  MapIcon,
  ListIcon,
  CloseIcon,
  SortDownIcon,
  FoodAndDrinkIcon,
  TwoSliderHorizontalIcon,
} from "../../icons";
import RegionPickerMobile from "../region-picker/mobile";
import CalendarPicker from "../calendar-picker";
import SeatPicker from "../seat-picker";
import moment from "moment";
import { useFilterContext } from "./filter-context";
import { observer } from "mobx-react-lite";
import { usePresenceTransition } from "./hooks";
import { SortFilter } from "../filters/sort";
import { AllFilter } from "../filters/all";
import { getQuery } from "@/service/http";
import { useTranslation } from "react-i18next";
import "../filters/index.less";

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
    >
      <path
        d="M10.501 19.5257C15.0504 19.5257 18.7384 15.3467 18.7384 10.1916C18.7384 5.03647 15.0504 0.857422 10.501 0.857422C5.95166 0.857422 2.26367 5.03647 2.26367 10.1916C2.26367 15.3467 5.95166 19.5257 10.501 19.5257Z"
        fill="white"
      />
      <path
        d="M9.79945 23.7326C3.15191 18.3083 0 13.9026 0 10.1711C0 10.0502 0 9.93144 0 9.81121C0.0899148 7.12275 1.2458 4.57967 3.21399 2.74011C5.18218 0.900542 7.80187 -0.0852265 10.4981 -0.000857318C10.6224 -0.000857318 10.749 -0.000857318 10.8726 -0.000857318C12.2073 0.00325248 13.5281 0.269664 14.7596 0.783144C15.991 1.29662 17.1088 2.0471 18.0492 2.99167C18.9895 3.93624 19.734 5.05637 20.2399 6.28802C20.7458 7.51967 21.0034 8.83868 20.9978 10.1696C20.9978 13.8981 17.8473 18.309 11.5495 23.7311C11.2928 23.9175 10.9802 24.0115 10.6629 23.9976C10.3524 24.0159 10.0458 23.9217 9.79945 23.7326ZM8.80423 8.03996L10.3851 14.4327C10.418 14.5958 10.3849 14.7652 10.293 14.904C10.2011 15.0428 10.0579 15.1397 9.89456 15.1735C9.71288 15.2493 9.56501 15.3883 9.47849 15.5647C9.39197 15.7411 9.3727 15.9428 9.42428 16.1323L9.85262 17.7161C10.0316 17.7288 10.2136 17.7355 10.3955 17.7363C11.0614 17.7405 11.7253 17.6653 12.3732 17.5123L12.5627 16.0054L12.0542 15.9359C12.0073 15.9305 11.962 15.9158 11.9208 15.8928C11.8796 15.8697 11.8434 15.8388 11.8143 15.8017C11.7852 15.7646 11.7637 15.7221 11.7512 15.6767C11.7386 15.6313 11.7353 15.5839 11.7412 15.5372L13.0727 6.08651C13.0727 6.08651 13.2097 4.36156 14.5112 4.36156L15.5192 4.49746C15.5662 4.50309 15.6117 4.51796 15.6529 4.5412C15.6942 4.56445 15.7304 4.59561 15.7595 4.63289C15.7886 4.67018 15.81 4.71284 15.8225 4.75842C15.835 4.80401 15.8383 4.8516 15.8322 4.89846L14.1001 16.8955C15.4189 16.2624 16.5343 15.2749 17.3209 14.044C18.1074 12.8132 18.5338 11.3878 18.552 9.92845V9.83436C18.521 7.7208 17.6497 5.70601 16.1294 4.23291C14.6092 2.75982 12.5645 1.94901 10.445 1.97873C8.32539 1.94901 6.28074 2.75982 4.7605 4.23291C3.24025 5.70601 2.36887 7.7208 2.33791 9.83436C2.34204 11.5321 2.89562 13.1832 3.9163 14.5421C4.93699 15.9009 6.37026 16.895 8.00296 17.3764L7.71315 16.5191C7.66924 16.3221 7.55555 16.1475 7.39297 16.0274C7.23038 15.9072 7.02979 15.8496 6.82801 15.865C6.66516 15.9061 6.49262 15.8824 6.34706 15.7987C6.20149 15.7151 6.09438 15.5781 6.04846 15.4169L4.46539 9.02789C4.44713 8.9895 4.4367 8.94787 4.43469 8.90543C4.42992 8.81205 4.46255 8.72061 4.5254 8.65122C4.58824 8.58183 4.67616 8.54017 4.7698 8.53542C4.86344 8.53067 4.95514 8.5632 5.02473 8.62587C5.09432 8.68854 5.13609 8.77621 5.14085 8.86958L5.19927 9.11451L6.2529 13.3268C6.25439 13.363 6.26305 13.3985 6.27836 13.4314C6.31202 13.4995 6.37086 13.5519 6.4425 13.5777C6.51414 13.6035 6.593 13.6005 6.66252 13.5695C6.69679 13.5547 6.72775 13.5333 6.75355 13.5063C6.77936 13.4794 6.79949 13.4476 6.81276 13.4128C6.82602 13.378 6.83215 13.3409 6.83078 13.3037C6.82942 13.2665 6.82058 13.2299 6.8048 13.1962L5.75192 8.98533L5.69126 8.7404C5.68474 8.7212 5.67998 8.70146 5.67703 8.68141C5.67128 8.6367 5.67449 8.59129 5.68647 8.54782C5.69846 8.50436 5.71898 8.4637 5.74684 8.4282C5.77471 8.39271 5.80936 8.36308 5.8488 8.34104C5.88823 8.31901 5.93166 8.305 5.97657 8.29983C6.06598 8.28814 6.15645 8.3115 6.22894 8.36498C6.30143 8.41846 6.35028 8.4979 6.36522 8.58657L6.42588 8.82179L7.47951 13.0393C7.48031 13.0418 7.48031 13.0444 7.47951 13.0468C7.49443 13.1237 7.53906 13.1917 7.60377 13.2361C7.66848 13.2806 7.74811 13.2978 7.82548 13.2843C7.86338 13.2732 7.89866 13.2547 7.92924 13.2298C7.95982 13.2049 7.98507 13.1741 8.00351 13.1393C8.02195 13.1045 8.03319 13.0663 8.03656 13.0271C8.03994 12.9879 8.03539 12.9483 8.02318 12.9109L6.97104 8.70157L6.90739 8.45664C6.9006 8.43773 6.89558 8.41823 6.89242 8.3984C6.88666 8.35368 6.88987 8.30828 6.90186 8.26481C6.91384 8.22135 6.93436 8.18069 6.96223 8.14519C6.99009 8.10969 7.02474 8.08007 7.06418 8.05803C7.10362 8.03599 7.14705 8.02199 7.19196 8.01682C7.28218 8.00389 7.37389 8.02676 7.4474 8.08051C7.52091 8.13426 7.57035 8.21461 7.5851 8.30431L7.64351 8.54326L8.64472 12.6271L8.68142 12.7765C8.69587 12.8544 8.74028 12.9237 8.80519 12.9694C8.8701 13.0152 8.95037 13.0338 9.02888 13.0214C9.06658 13.01 9.10163 12.9913 9.13205 12.9663C9.16247 12.9413 9.18765 12.9106 9.20616 12.8759C9.22466 12.8413 9.23612 12.8033 9.23988 12.7642C9.24364 12.7251 9.23963 12.6856 9.22808 12.6481L9.19139 12.4905L8.19317 8.43723L8.13476 8.19827C8.12231 8.1664 8.11425 8.13299 8.11079 8.09896C8.10744 8.05421 8.11304 8.00925 8.12728 7.96669C8.14151 7.92413 8.1641 7.88482 8.19372 7.85105C8.22334 7.81727 8.2594 7.78971 8.2998 7.76997C8.3402 7.75022 8.38414 7.73869 8.42906 7.73604H8.45901C8.54416 7.73479 8.62671 7.76524 8.69055 7.82144C8.75439 7.87764 8.79492 7.95556 8.80423 8.03996Z"
        fill="#FE295A"
      />
    </svg>
  );
};
const Profile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1.70001 17.7333C3.46265 15.3831 6.22893 14 9.16667 14H12.8333V16H9.16667C6.85845 16 4.68493 17.0868 3.3 18.9333L3.24999 19C3.08772 19.2164 3 19.4795 3 19.75C3 20.4404 3.55964 21 4.25 21H13V23H4.25C2.45508 23 1 21.5449 1 19.75C1 19.0468 1.22808 18.3626 1.65 17.8L1.70001 17.7333Z"
        fill="#252525"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C9.1311 1 7 3.57642 7 6.5C7 9.42358 9.1311 12 12 12C14.8689 12 17 9.42358 17 6.5C17 3.57642 14.8689 1 12 1ZM12 3C10.4506 3 9 4.45302 9 6.5C9 8.54698 10.4506 10 12 10C13.5494 10 15 8.54698 15 6.5C15 4.45302 13.5494 3 12 3Z"
        fill="#252525"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8634 14.8451C19.2936 13.7183 17.7064 13.7183 17.1366 14.8451L16.53 16.0445L15.2647 16.2729C14.0118 16.4991 13.6183 18.0134 14.4195 18.8734L15.3373 19.8586L15.1486 21.2276C14.9897 22.38 16.1728 23.4396 17.3578 22.8317L18.5 22.2458L19.6422 22.8317C20.8272 23.4396 22.0103 22.38 21.8514 21.2276L21.6627 19.8586L22.5805 18.8734C23.3817 18.0134 22.9882 16.4991 21.7353 16.2729L20.47 16.0445L19.8634 14.8451ZM18.5 16.5808L18.2122 17.1498C17.9991 17.5713 17.6002 17.8836 17.1172 17.9708L16.4279 18.0952L16.9419 18.647C17.2665 18.9955 17.4097 19.47 17.3461 19.9316L17.2485 20.64L17.8085 20.3527C18.2433 20.1296 18.7567 20.1296 19.1915 20.3527L19.7515 20.64L19.6539 19.9316C19.5903 19.47 19.7335 18.9954 20.0581 18.647L20.5721 18.0952L19.8828 17.9708C19.3998 17.8836 19.0009 17.5713 18.7878 17.1498L18.5 16.5808Z"
        fill="#252525"
      />
    </svg>
  );
};

// Mobile 只管理自己的 UI 状态（表单开关、搜索值、日期、人数等）
const MobileHeadBar = () => {
  const { t } = useTranslation();
  const {
    searchState: filterState,
    setSearchState: setFilterState,
    regionList,
    currentCity,
    pageCity,
    onHomeClick,
    onUserClick,
    onCityClick,
    onSearchBtnClick,
    activeTab,
    exploreMapMode,
    setExploreMapMode,
  } = useFilterContext();

  const SEARCH_RECORDS_STORAGE_KEY = "search_records";
  const FORM_TRANSITION_MS = 200;

  const readSearchRecords = useCallback(() => {
    if (typeof window === "undefined") return [];
    try {
      const raw = window.localStorage.getItem(SEARCH_RECORDS_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => typeof item === "string" && item.trim());
    } catch (e) {
      return [];
    }
  }, []);

  const writeSearchRecords = useCallback((records) => {
    if (typeof window === "undefined") return;
    try {
      window.localStorage.setItem(
        SEARCH_RECORDS_STORAGE_KEY,
        JSON.stringify(records)
      );
    } catch (e) {
      // ignore
    }
  }, []);

  const [showRegionPicker, setShowRegionPicker] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState("");
  const [showCalendarPicker, setShowCalendarPicker] = useState(false);
  const [searchRecords, setSearchRecords] = useState([]);
  const [searchValue, setSearchValue] = useState(filterState.q || "");

  const seatPickerValue = useMemo(() => {
    const n = Number(filterState.seats || 0);
    return Number.isFinite(n) ? n : 0;
  }, [filterState.seats]);

  const setSeatPickerValue = useCallback(
    (val) => {
      const n = Number(val || 0);
      setFilterState({ seats: n > 0 ? String(n) : "" });
    },
    [setFilterState]
  );

  const datePickerValue = useMemo(() => {
    if (!filterState.date) return null;
    if (filterState.date instanceof Date) return filterState.date;
    const m = moment(filterState.date, ["YYYY-MM-DD", moment.ISO_8601], true);
    if (!m.isValid()) return null;
    return m.toDate();
  }, [filterState.date]);

  const setDatePickerValue = useCallback(
    (val) => {
      if (!val) {
        setFilterState({ date: "" });
        return;
      }
      const next = val instanceof Date ? moment(val) : moment(val);
      setFilterState({ date: next.isValid() ? next.format("YYYY-MM-DD") : "" });
    },
    [setFilterState]
  );

  useEffect(() => {
    let timer;
    if (showForm) {
      setFormVisible(true);
      if (
        typeof window !== "undefined" &&
        typeof window.requestAnimationFrame === "function"
      ) {
        window.requestAnimationFrame(() => setFormOpen(true));
      } else {
        setFormOpen(true);
      }
    } else {
      setFormOpen(false);
      timer = setTimeout(() => setFormVisible(false), FORM_TRANSITION_MS);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [FORM_TRANSITION_MS, showForm]);

  useEffect(() => {
    setSearchRecords(readSearchRecords());
  }, [readSearchRecords]);

  const addSearchRecord = useCallback(
    (value) => {
      const query = (value || "").trim();
      if (!query) return;

      setSearchRecords((prev) => {
        const prevList = Array.isArray(prev) ? prev : [];
        const normalized = query.toLowerCase();
        const next = [
          query,
          ...prevList.filter(
            (item) => (item || "").trim().toLowerCase() !== normalized
          ),
        ].slice(0, 10);
        writeSearchRecords(next);
        return next;
      });
    },
    [writeSearchRecords]
  );

  const onSearchClick = useCallback(
    (keyword) => {
      const query = (keyword || "").trim();
      if (query) addSearchRecord(query);
      // 跳转到搜索结果页
      setFilterState({ q: query });
      onSearchBtnClick(query, filterState.regionInfo?.key_word);
      setShowForm(false);
    },
    [addSearchRecord, onSearchBtnClick]
  );

  const cancelSearch = () => {
    setShowForm(false);
    setShowCalendarPicker(false);
    const { q, date, seats } = getQuery();
    setFilterState({ q, date, seats });
  };
  const dateFormat = useMemo(() => {
    if (!datePickerValue) return t("Header.Date");
    if (moment.locale().startsWith("zh")) {
      return moment(datePickerValue).format("MMMD日");
    }
    return moment(datePickerValue).format("MMM D");
  }, [datePickerValue]);
  const originalBodyOverflowRef = useRef(null);

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (originalBodyOverflowRef.current === null) {
      originalBodyOverflowRef.current = document.body.style.overflow || "";
    }
    return () => {
      document.body.style.overflow = originalBodyOverflowRef.current || "";
    };
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") return;
    // On /browse we want container scrolling only (body locked).
    const isBrowse = activeTab === "explore";
    const shouldLockBody = showRegionPicker || isBrowse;
    document.body.style.overflow = shouldLockBody
      ? "hidden"
      : originalBodyOverflowRef.current || "auto";
  }, [activeTab, showRegionPicker]);

  const handleCityClick = useCallback(
    (city) => {
      onCityClick(city);
      setShowRegionPicker(false);
    },
    [onCityClick]
  );

  const shouldFilterFocusMode =
    activeTab === "explore" &&
    !formVisible &&
    Boolean(filtersOpen) &&
    filtersOpen !== "sort";
  const { isPresent: isFilterFocusMode } = usePresenceTransition(
    shouldFilterFocusMode,
    200
  );

  const { searchState } = useFilterContext();

  let hasVal = searchState?.q || searchState?.date || searchState?.seats;

  const handleCancelSearch = useCallback(() => {
    cancelSearch();
  }, [cancelSearch]);

  const HeadLeft = () => {
    return showForm ? (
      <div className="ui-mobile" onClick={handleCancelSearch}>
        <BackIcon></BackIcon>
      </div>
    ) : (
      <>
        {" "}
        <div className="ui-mobile-search__logo" onClick={onHomeClick}>
          <Logo />
        </div>
        <div className="ui-mobile-search__profile" onClick={onUserClick}>
          <Profile />
        </div>
      </>
    );
  };

  const HeadRight = () => {
    if (activeTab === "explore" && !showForm) {
      return (
        <div
          className="ui-mobile-search__map-toggle"
          onClick={() => setExploreMapMode(!exploreMapMode)}
        >
          {exploreMapMode ? <ListIcon /> : <MapIcon />}
        </div>
      );
    }
    return (
      <div
        className="ui-mobile-search__region"
        onClick={() => setShowRegionPicker(true)}
      >
        <NavigationIcon />
        <span>{pageCity?.name}</span>
      </div>
    );
  };

  return (
    <div
      className="ui-mobile-head-bar"
      style={{ minHeight: isFilterFocusMode ? 100 : undefined }}
    >
      <div
        className={cn("ui-mobile-head-bar__search", {
          "is-hidden": shouldFilterFocusMode,
        })}
      >
        <div className="ui-mobile-search">
          <HeadLeft />
          {!showForm && hasVal && activeTab === "explore" ? (
            <SearchMotion
              dateFormat={dateFormat}
              onSearch={() => {
                setShowForm(true);
                setSearchValue(filterState.q || "");
              }}
            ></SearchMotion>
          ) : (
            <div
              className={cn("ui-mobile-search__input", {
                active: Boolean((searchValue || "").trim()),
              })}
            >
              <input
                type="text"
                placeholder={t("Header.SearchRestaurants")}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                onFocus={() => {
                  setShowForm(true);
                }}
              />
              <div className="ui-mobile-search__inputIcon">
                <SearchIcon />
              </div>
            </div>
          )}
          <HeadRight />
        </div>
      </div>
      {showRegionPicker && (
        <RegionPickerMobile
          SearchIcon={<SearchIcon />}
          onCityClick={handleCityClick}
          setShowRegionPicker={setShowRegionPicker}
          regions={regionList}
          currentCity={currentCity}
          pageCity={pageCity}
        />
      )}
      {formVisible && (
        <div
          className={cn("ui-mobile-search__form", {
            "is-open": formOpen,
          })}
        >
          <div className="ui-mobile-search__form-item">
            <SeatPicker
              mobile={true}
              value={seatPickerValue}
              onChange={setSeatPickerValue}
            ></SeatPicker>
          </div>
          <div className="ui-mobile-search__form-item">
            <div className="form-item-label">
              <CalendarIcon></CalendarIcon>
              <span style={{ color: datePickerValue ? "var(--text-color)" : null }}>{dateFormat}</span>
            </div>
            <div
              className="form-item-action"
              onClick={() => setShowCalendarPicker(!showCalendarPicker)}
            >
              { t("Header.Select date") }
            </div>
          </div>
          {showCalendarPicker && (
            <CalendarPicker
              mobile={true}
              value={datePickerValue}
              onChange={setDatePickerValue}
            ></CalendarPicker>
          )}
          {!!datePickerValue && showCalendarPicker ? (
            <div
              className="ui-mobile-search__form-btn"
              onClick={() => setShowCalendarPicker(false)}
            >
              { t("Header.Next step") }
            </div>
          ) : (
            <div
              className="ui-mobile-search__form-btn"
              onClick={() => onSearchClick(searchValue)}
            >
              {t("Header.Search")}
            </div>
          )}

          {searchRecords.length > 0 && (
            <div className="ui-mobile-search__records">
              <div className="records-title">{t("Header.Previous searches")}</div>
              <div className="records-list">
                {searchRecords.map((item) => (
                  <div
                    key={item}
                    className="record-item"
                    onClick={() => {
                      onSearchClick(item);
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {activeTab === "explore" && !formVisible && (
        <HeaderFilters
          open={filtersOpen}
          setOpen={setFiltersOpen}
          isFilterFocusMode={isFilterFocusMode}
          showTitle={shouldFilterFocusMode}
        ></HeaderFilters>
      )}
    </div>
  );
};

const HeaderFilters = observer(({ open, setOpen, isFilterFocusMode, showTitle }) => {
  const { t } = useTranslation();
  const { sums } = useFilterContext();
  const { isPresent: isSortPresent, phase: sortPhase } = usePresenceTransition(
    !isFilterFocusMode,
    200
  );

  const { isPresent: isPanelPresent, phase: panelPhase } =
    usePresenceTransition(Boolean(open), 200);
  const [panelKey, setPanelKey] = useState(open);
  useEffect(() => {
    if (open) setPanelKey(open);
  }, [open]);
  const isPanelVisible = panelPhase === "entering" || panelPhase === "entered";

  const filterItems = useMemo(() => {
    const items = [];
    if (isSortPresent) {
      items.push({
        key: "sort",
        icon: <SortDownIcon></SortDownIcon>,
        label: t("Browse.sort"),
        _phase: sortPhase,
      });
    }

    items.push({
      key: "filters",
      icon: <TwoSliderHorizontalIcon></TwoSliderHorizontalIcon>,
      label: isFilterFocusMode ? t("Header.All") : t("Browse.filters"),
    });
    items.push({
      key: "location",
      icon: <NavigationIcon></NavigationIcon>,
      label: t("Browse.location"),
    });
    items.push({
      key: "cuisines",
      icon: <FoodAndDrinkIcon></FoodAndDrinkIcon>,
      label: t("Browse.cuisines"),
    });
    return items;
  }, [isFilterFocusMode, isSortPresent, sortPhase]);

  const clickTab = (key) => {
    setOpen(key);
    const scrollIdMap = {
      filters: "scroll-filters",
      location: "scroll-location",
      cuisines: "scroll-cuisines",
    };
    const targetId = scrollIdMap[key];
    if (!targetId || typeof window === "undefined") return;

    const raf =
      typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame
        : (cb) => setTimeout(cb, 0);

    raf(() => {
      raf(() => {
        const target = document.getElementById(targetId);
        if (!target) return;
        try {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        } catch (e) {
          target.scrollIntoView();
        }
      });
    });
  };

  return (
    <>
      {isFilterFocusMode && (
        <div
          className={cn("ui-mobile-head-bar__filter-title", {
            "is-expanded": showTitle,
            "is-collapsing": !showTitle,
          })}
        >
          <span></span>
          <span>{ t("Browse.filters") }</span>
          <div
            className="ui-mobile-head-bar__filter-close"
            onClick={() => setOpen("")}
          >
            <CloseIcon></CloseIcon>
          </div>
        </div>
      )}
      <div className="ui-mobile-head-bar__filters">
        {filterItems.map((item) => {
          const isCollapsingSort =
            item.key === "sort" && item._phase === "exiting";
          return (
            <div
              className={cn("filter-item", {
                active: open === item.key,
                "is-collapsing": isCollapsingSort,
              })}
              key={item.key}
              onClick={() => (isCollapsingSort ? null : clickTab(item.key))}
            >
              {item.icon}
              <span>{item.label}</span>
              {sums[item.key] > 0 && (
                <div className="filter-item-badge">{sums[item.key]}</div>
              )}
            </div>
          );
        })}
      </div>
      {isPanelPresent && panelKey && (
        <div
          className={cn("ui-mobile-head-bar__filter-panel", {
            "is-open": isPanelVisible,
          })}
        >
          {panelKey === "sort" ? (
            <SortFilter setOpen={setOpen}></SortFilter>
          ) : (
            <AllFilter setOpen={setOpen}></AllFilter>
          )}
        </div>
      )}
    </>
  );
});

const SearchMotion = ({ onSearch, dateFormat }) => {
  const { searchState, pageCity } = useFilterContext();
  const { t } = useTranslation();
  return (
    <div className="search-motion" onClick={onSearch}>
      <div className="search-motion-content">
        {searchState?.q && pageCity ? (
          <div
            className="search-motion-one"
            dangerouslySetInnerHTML={{
              __html: t("Header.{keyword} in {city}", {
                keyword: searchState?.q,
                city: pageCity?.name,
              }),
            }}
          ></div>
        ) : null}
        {(searchState?.date || searchState?.seats) && (
          <div className="search-motion-two">
            {!!searchState?.date && (
              <div className="search-motion-val">{dateFormat}</div>
            )}
            {searchState?.date && searchState?.seats ? (
              <div className="search-motion-div">·</div>
            ) : null}
            {!!searchState?.seats && (
              <div className="search-motion-val">{t('Header.{count} Guests', {count: Number(searchState?.seats)})}</div>
            )}
          </div>
        )}
      </div>
      <SearchIcon className="search-motion-icon"></SearchIcon>
    </div>
  );
};

export default observer(MobileHeadBar);
